export default {"src":"/_next/static/media/menu.ae9f2f4c.svg","height":18,"width":26,"blurWidth":0,"blurHeight":0};